import getFutureDateAndTime from "./getFutureDateAndTime";


const getCurrentDatePlusHours = (hoursToAdd, date = new Date()) => {
    const updatedDate = new Date(date.getTime() + hoursToAdd * 60 * 60 * 1000);

    
    // Formatlayıcılar
    const dateFormatter = new Intl.DateTimeFormat('tr-TR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });

    const timeFormatter = new Intl.DateTimeFormat('tr-TR', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false // 24 saat formatı
    });

    
    const formatted = getFutureDateAndTime(updatedDate)

    
    // Formatlanmış tarih ve zaman döndürme
    return {
        date: dateFormatter.format(updatedDate),
        time: timeFormatter.format(updatedDate),
        formattedDate: formatted.formattedDate,
        formattedTime: formatted.formattedTime 
    };
}

export default getCurrentDatePlusHours